exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".transfer-project-pagination-buttons {\n  display: flex;\n  justify-content: center; }\n", ""]);

